import { HomePage, SIFPage, ProfilePage, SIFUploadPage, SIFCompanyDataPage,
  ManageUsersPage, ManageCompaniesPage, SIFEventPage, HSEPage, HSECompanyDataPage,
  HSEUploadPage, HSECompanyDataDetailsPage, ESGPage, ESGCompanyDataPage,
  ESGUploadPage, ESGCompanyDataDetailsPage, AXPCAssistantPage, AIKnowledgeBasePage
} from './pages';
import { withNavigationWatcher } from './contexts/navigation';

const routes = [
    {
        path: '/axpc-assistant',
        element: AXPCAssistantPage
    },
    {
        path: '/ai-knowledge-base',
        element: AIKnowledgeBasePage
    },
    {
        path: '/sif',
        element: SIFPage
    },
    {
        path: '/hse',
        element: HSEPage
    },
    {
        path: '/sifupload',
        element: SIFUploadPage
    },
    {
        path: '/hseupload/:year/:company_id',
        element: HSEUploadPage
    },
    {
        path: '/hseupload',
        element: HSEUploadPage
    },
    {
        path: '/sifdata',
        element: SIFCompanyDataPage
    },
    {
        path: '/hsedata',
        element: HSECompanyDataPage
    },
    {
        path: '/hsedata/:year',
        element: HSECompanyDataPage
    },
    {
        path: '/hsecompanydata/:year/:company_id',
        element: HSECompanyDataDetailsPage
    },
    {
        path: '/sifevent',
        element: SIFEventPage
    },

    {
        path: '/esg',
        element: ESGPage
    },
    {
        path: '/esgupload/:year/:company_id',
        element: ESGUploadPage
    },
    {
        path: '/esgupload',
        element: ESGUploadPage
    },
    {
        path: '/esgdata',
        element: ESGCompanyDataPage
    },
    {
        path: '/esgdata/:year',
        element: ESGCompanyDataPage
    },
    {
        path: '/esgcompanydata/:year/:company_id',
        element: ESGCompanyDataDetailsPage
    },

    {
        path: '/profile',
        element: ProfilePage
    },
    {
        path: '/home',
        element: HomePage
    },
    {
        path: '/admin-users',
        element: ManageUsersPage
    },
    {
        path: '/admin-companies',
        element: ManageCompaniesPage
    }
];

export default routes.map(route => {
    return {
        ...route,
        element: withNavigationWatcher(route.element, route.path)
    };
});
